var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg360View1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_590_821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3202 25.1955H26.6704V19.3201H11.3032L13.53 14.3348C13.7635 13.7942 14.2938 13.4447 14.8813 13.4447H23.9442C23.6607 11.9596 23.6563 10.5539 23.9501 9.03809H14.8813C12.5282 9.03809 10.4087 10.4364 9.48181 12.5986L6.29733 20.031C4.44217 21.0195 3.16279 22.9511 3.16279 25.1955V28.1332C3.16279 30.2983 4.35257 32.1726 6.10051 33.192V38.4152C6.10051 40.0354 7.41807 41.3529 9.03822 41.3529H13.4448C15.0649 41.3529 16.3825 40.0354 16.3825 38.4152V34.0086H26.6704V28.1332H19.3202C18.5094 28.1332 17.8514 27.4752 17.8514 26.6644C17.8514 25.8536 18.5094 25.1955 19.3202 25.1955ZM11.2415 30.3365C9.21301 30.3365 7.56936 28.6929 7.56936 26.6644C7.56936 24.6359 9.21301 22.9922 11.2415 22.9922C13.27 22.9922 14.9136 24.6359 14.9136 26.6644C14.9136 28.6929 13.27 30.3365 11.2415 30.3365Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1763 9.73876C43.5697 6.26198 40.6525 3.7752 38.981 3.26845C38.699 3.18325 38.4214 3.40652 38.4214 3.70029V11.0695C38.4214 11.6262 38.107 12.1345 37.6091 12.3827L36.1402 13.1171C35.726 13.3242 35.2398 13.3242 34.8271 13.1171L33.3582 12.3827C32.8603 12.1345 32.5459 11.6248 32.5459 11.0695V3.70029C32.5459 3.40505 32.2668 3.18178 31.9834 3.26845C30.3103 3.78695 27.3946 6.31192 26.7924 9.75932C26.2754 12.7205 27.3858 15.6245 29.1382 17.3783C29.4261 17.6662 29.6067 18.0378 29.6067 18.4447V38.4167C29.6067 41.66 32.236 44.2892 35.4792 44.2892C38.7225 44.2892 41.3517 41.66 41.3517 38.4167L41.3561 18.452C41.3561 18.0407 41.5427 17.6618 41.8335 17.3695C43.5976 15.6068 44.6919 12.6897 44.1763 9.73876ZM35.491 40.6185C34.2748 40.6185 33.2877 39.6315 33.2877 38.4152C33.2877 37.199 34.2748 36.212 35.491 36.212C36.7072 36.212 37.6943 37.199 37.6943 38.4152C37.6943 39.6315 36.7072 40.6185 35.491 40.6185Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_590_821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.4167,
    height: 46.4167,
    fill: "white",
    transform: "scale(1.01257)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg360View1);
export default __webpack_public_path__ + "static/media/360-view-1.f2c9164cacdc494e132ace58f6b2012e.svg";
export { ForwardRef as ReactComponent };